import { Report } from "../../../Interfaces/TableInterfaces";
import { IBrokerOrdersSearchParam } from "../../../Interfaces/stepInterfaces";
import TableTemplate from "../../TableTemplate/tableTemplate";
import BrokerOrdersTableUI from "./BrokerOrdersTableUI";

interface IProps {
  getData: (
    searchParameters: IBrokerOrdersSearchParam,
    offset: number | null,
    pageSize: number | null
  ) => Promise<Report<any>>;
  shekarOrderId?: number;
  stepOrderId?: number;
  orderId?: number;
  upairId?: number;
  nlegId?: number;
}

const BrokerOrdersTable = ({
  getData,
  shekarOrderId,
  stepOrderId,
  orderId,
  upairId,
  nlegId,
}: IProps) => {
  return (
    <TableTemplate<IBrokerOrdersSearchParam, any>
      getDataTable={getData}
      TableUI={BrokerOrdersTableUI}
      showIsLoading
      initialSearchParameters={{
        shekarOrderId,
        stepOrderId,
        orderId,
        upairId,
        nlegId,
      }}
    />
  );
};

export default BrokerOrdersTable;
